import React from 'react';
import styles from './loader.module.css';


const Loader = () => {
    return (
        <div className={styles.loaderCont}>
            <img
                className={styles.loaderIcon}
                src="/apple-touch-icon.png"
                alt="Loading"
            />
        </div>
    );
};

export default Loader;
